// extracted by mini-css-extract-plugin
export var alertIcon = "_q9-0";